import React, { useState } from 'react';
import MenuOperaciones from '../menuOperaciones';
import GestorUsuariosOperaciones from '../UsuarioOperaciones';

function VerUsuariosOperaciones() {
  const [menuOpen, setMenuOpen] = useState(true);
  const sidebarWidth = menuOpen ? 250 : 74;

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#0c1f1d' }}>
      <MenuOperaciones
        defaultOpen={menuOpen}
        onToggle={(next) => setMenuOpen(next)}
      />

      <main
        className="contenido-panel"
        style={{
          marginLeft: sidebarWidth,
          width: '100%',
          transition: 'margin-left .25s ease',
          padding: 20,
          background: 'radial-gradient(900px 600px at -10% -10%, #183c34 0%, transparent 45%), #0c1f1d'
        }}
      >
        <GestorUsuariosOperaciones />
      </main>
    </div>
  );
}

export default VerUsuariosOperaciones;
